const MenuItems = [
    {
        title: 'Inicio',
        url: '/',
        cName: 'nav-links'
    },
    {
        title: 'Productos',
        url: '/products',
        cName: 'nav-links'
    },
    {
        title: 'Nosotros',
        url: '/',
        cName: 'nav-links'
    },
    {
        title: 'Contactanos',
        url: '/',
        cName: 'nav-links'
    }
]

export default MenuItems